import { connect } from 'react-redux';
import TinyRevenue from '../views/tiny/TinyRevenue';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyRevenueContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyRevenue);

export default TinyRevenueContainer;


